import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExpiredTrialActionChecker } from 'modules/core/components/ExpiredTrialActionChecker'
import TextInput from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import Schema from 'modules/custom_resources/store/models/customResources/Schema'
import { SchemaForm } from 'modules/settings/components/CustomizationSettings/CustomResources/_Component/_NewModal'

interface Props {
  schema: Schema
  updateSchema: (name: string) => Promise<unknown>
}

const Details = ({ schema, updateSchema }: Props) => {
  const readonly = schema.attributes.topic === Schema.TOPIC_NAMES.performance
  const {
    company: { subscription },
  } = useCurrentSession()

  const form = useMemo(
    () =>
      new SchemaForm({
        name: schema.attributes.name,
      }),
    [schema.attributes.name]
  )

  const { running, performAction } = useAsyncAction(() => {
    return updateSchema(form.get('name').value)
  })

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="document-edit"
        title={i18n.t('settings.custom_table.details.title')}
        description={i18n.t('settings.custom_table.details.description')}
      />
      <Box>
        <Box gap="s8">
          <TextInput
            field={form.get('name')}
            label={i18n.t('settings.custom_table.details.name_label')}
            placeholder={i18n.t('settings.custom_table.details.name_placeholder')}
            readonly={readonly}
          />
          {form.get('name').isDirty && (
            <ExpiredTrialActionChecker subscription={subscription} onClick={performAction}>
              <Box alignItems="flexEnd">
                <Button disabled={running}>{i18n.t('settings.custom_table.details.submit')}</Button>
              </Box>
            </ExpiredTrialActionChecker>
          )}
        </Box>
      </Box>
    </PanesPadForm>
  )
}

export default observer(Details)
